import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import moment from 'moment';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ServiceItem } from '../..';
import * as fromLookups from '../../../lookups';
import {
    DynamicDialogConfig,
    DynamicDialogRef,
    SelectItem
} from '../../../shared';
import { LoggingService } from '../../../shared/services/logging';
import * as fromStore from '../../store';
@Component({
    selector: 'ef-sync-dialog-container',
    templateUrl: './sync-dialog-container.component.html',
    styleUrls: ['./sync-dialog-container.component.scss'],
    standalone: false
})
export class SyncDialogContainerComponent implements OnInit {
    public SyncType: string;
    payperiodSelectItems$: Observable<SelectItem[]>;
    scheduledDates$: Observable<fromLookups.ScheduledDate[]>;
    serviceItems$: Observable<ServiceItem[]>;
    startDate: Date;
    endDate: Date;
    fromPeriods: SelectItem[];
    constructor(
        public ref: DynamicDialogRef,
        private config: DynamicDialogConfig,
        private log: LoggingService,
        private store: Store
    ) {
        this.log.verbose({ type: 'SyncDialogContainerComponent', config });
        if (config && config.data) {
            this.SyncType = config.data.syncType;
            [this.startDate, this.endDate] = config.data.dates;
            this.fromPeriods = config.data.fromPeriods;
        }
    }

    ngOnInit(): void {
        this.scheduledDates$ = this.store.pipe(
            select(fromLookups.ScheduledDateSelectors.selectAll),
            filter(dates => !!dates && dates.length > 0)
        );
        this.payperiodSelectItems$ = this.scheduledDates$.pipe(
            filter(dates => !!dates && dates.length > 0),
            filter(() => !!this.startDate && !!this.endDate),
            map(dates =>
                dates
                    .filter(d => d.ScheduledDateType === 'PPE')
                    .filter(
                        d =>
                            moment(d.ScheduledStartDate).isBetween(
                                moment(this.startDate),
                                moment(this.endDate)
                            ) ||
                            moment(d.ScheduledEndDate).isBetween(
                                moment(this.startDate),
                                moment(this.endDate)
                            )
                    )
                    .map(d => ({
                        label: `${moment(d.ScheduledStartDate).format(
                            'MM/DD/YYYY'
                        )} - ${moment(d.ScheduledEndDate).format(
                            'MM/DD/YYYY'
                        )}`,
                        value: `${moment(d.ScheduledStartDate).format(
                            'MM/DD/YYYY'
                        )}-${moment(d.ScheduledEndDate).format('MM/DD/YYYY')}`
                    }))
            )
        );
        this.serviceItems$ = this.store.pipe(
            select(fromStore.selectAll),
            filter(items => !!items && items.length > 0),
            map(items => clone(items))
        );
    }
}
